export const FETCH_FAV_LINE_SUCCESS = 'fetchFavLineSuccess';
export const FETCH_FAV_LINE_FAV_CELLS_SUCCESS = 'fetchFavLineFavCellsSuccess';
export const FETCH_FAV_CELL_SUCCESS = 'fetchFavCellSuccess';
export const FETCH_USER_SUCCESS = 'fetchUserSuccess';
export const FETCH_UNLISTED_SITE_SUCCESS = 'fetchUnlistedSiteSuccess';
export const FETCH_MOST_POPULAR_SITE_SUCCESS = 'fetchMostPopularSiteSuccess';
export const ADMIN_MODE_SUCCESS = 'adminModeSuccess';
export const SET_TAB_CELL_EDITABLE_ID_ADMIN_M = 'setTabCellEditableIDAdminMutation';
export const RESET_TAB_CELL_EDITABLE_ID_ADMIN_M = 'resetTabCellEditableIDAdminMutation';
